<template>
  <div :class="containerClass">
    <input v-model="__modelValue" :id="inputId" type="checkbox" checked=""/>

    <label :for="inputId">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckboxFormInput',
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: String,
      default: 'remember_me'
    },
    label: {
      type: String,
      default: ''
    },
    containerClass: {
      type: String,
      default: 'remember_checkbox'
    }
  },
  computed: {
    __modelValue: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/formInput/BaseCheckboxFormInput.vue